import { omit } from 'lodash'
export const historyKeywordsStore = 'historyKeywordsStore' // 历史搜索的关键词表

export const AUTO_COMPLATE_OPEN_PARAMS = ['on', '1']
export const AUTO_COMPLATE_CLOSE_PARAMS = ['off', '0']

export const INPUT_TAG_NAME = 'INPUT'
export const ElHasInputComponents = {
  ElInput: 'ElInput',
  ElSelect: 'ElSelect',
  ElTimeSelect: 'ElTimeSelect',
  ElDatePicker: 'ElDatePicker',
  ElTimePicker: 'ElTimePicker',
  ElCascader: 'ElCascader',
  ElAutocomplete: 'ElAutocomplete',
  ElInputNumber: 'ElInputNumber',
  ElTable: 'ElTable'
}

export const AutocomplateInputModeMap = {
  autocomplate: 'autocomplate', // input或组件默认设置了类似的下拉异步查询类似：ElAutocomplete | ElSelect
}

export const KyeHasInputComponents = {
  KyeTimePicker: 'KyeTimePicker',
  KyeDatePicker: 'KyeDatePicker',
  KyeDatePicker2: 'KyeDatePicker2',
  KyeDatePicker3: 'KyeDatePicker3',
  KyeInputMoney: 'KyeInputMoney',
  KyeTable2: 'KyeTable2'
}

export const INPUT_COMPONENTS = {
  ...ElHasInputComponents,
  ...KyeHasInputComponents
}

// 需要关闭联想输入的关联组件
export const offAutocompleteComponents = Object.values(omit(
  {
    ...ElHasInputComponents,
    ...KyeHasInputComponents
  },
  ElHasInputComponents.ElInput
))



// WEBPACK FOOTER //
// ./src/layout/layout/setup/input-autocomplete/config.js